module.exports = __webpack_public_path__ + "img/bt-methodo-orange.e74019b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bt-methodo-orange.svg
// module id = fIQr
// module chunks = 7